module.exports = __webpack_public_path__ + "static/img/3-1.2ae8e977.png";